// extracted by mini-css-extract-plugin
export var caption = "index-module--caption--+YCoV";
export var fadein = "index-module--fadein--fCPZ9";
export var wrapper = "index-module--wrapper--6mMm0";